import React from 'react';
// import { Container, Row, Col, Button, Card, CardImg, CardGroup, CardText, CardBody, CardTitle, CardSubtitle } from 'reactstrap';
import {Card, CardGroup, Row, Col, Button, Alert, Image} from 'react-bootstrap';
import { Container } from 'reactstrap';
//import { Card } from 'react-bootstrap';
import Helmet from "react-helmet";
import { Link, withRouter, useHistory } from "react-router-dom";
import history from '../history';

import img1 from '../assets/images/contents/ccis.png';
import book1 from '../assets/images/contents/book1.jpg';
import book2 from '../assets/images/contents/book2.png';
import book4 from '../assets/images/contents/book5.jpg';

// import speaker1 from '../assets/images/contents/speaker1.jpg';
// import speaker2 from '../assets/images/contents/speaker2.jpg';
// import speaker3 from '../assets/images/contents/speaker3.jpg';
// import speaker4 from '../assets/images/contents/speaker4.jpg';
// import speaker5 from '../assets/images/contents/speaker5.jpg';
// import speaker6 from '../assets/images/contents/speaker6.jpg';
// import speaker7 from '../assets/images/contents/speaker7.jpg';
// import speaker8 from '../assets/images/contents/speaker8.jpg';

import speaker1 from "../assets/images/contents/DrUzirMahidin.jpg"
import speaker2 from "../assets/images/contents/DrEisukeKita.jpg"
import speaker3 from "../assets/images/contents/ProfDrAgusHarjoko.jpg"
import speaker4 from "../assets/images/contents/DrMazlanAbbas.jpg"
import speaker5 from "../assets/images/contents/AssociateProfDrKunZhan.jpg"


import poster from '../assets/images/contents/PosterSCDS2023.png';

import scds2023Logo from "../assets/images/contents/SCDS2023Logo.svg"

import sponsor from '../assets/images/contents/BannerFooterSCDS2023.svg';

// import 'bootstrap/dist/css/bootstrap.min.css';

import { Jumbotron } from '../Components/Jumbotron';

export const Home = () => (
  <div>
    <Helmet>
      <title>The 7th International Conference on Soft Computing in Data Science 2023 (SCDS2023) - Home</title>
      <meta name="description" content="The First and Second International Conference (SCDS2015, SCDS2016) were successfully held in Kuala Lumpur Malaysia." />
      <meta name="keywords" content="home, scds2023, scds 2023, uitm, ibdaai, shah alam, conference" />
    </Helmet>
     {/* <NavbarBrand href="/" style={{  justifyContent: "center",
          alignItems: "center", display: "flex",}}><img src={scds2020} alt="wrapkit" height= "1400px" width= "1000px"/></NavbarBrand> */}
    <title>The 7th International Conference on Soft Computing in Data Science 2023 (SCDS2023) - Home</title>

    {/* <NavigationBar />*/}
    <br/> 

    {/* <a style = {{color: 'red', fontSize: '2rem', cursor: 'pointer', lineHeight: '90%'}} className = "blinking" onClick={() => history.push('/scds2021/preconference')}>
    <b>Attention... Pre-Conference Workshops</b></a> */}  
     
     {/* <Image src={scds2023Logo} style={{ textAlign:'center', color: 'white', justifyContent: 'center', alignItems: 'center', display: 'block', marginLeft: 'auto', marginRight: 'auto',
            width: '100%'}}/><br/>  */}
    <br/><Jumbotron /> <br/>
    <h2>Introduction</h2>
    <div style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
    <p style={{ textAlign:'justify'}}>The First and Second International Conferences (SCDS2015, SCDS2016) were successfully held in Kuala Lumpur, Malaysia. Subsequently, SCDS2017 
        was successfully hosted by Universitas Gadjah Mada, Indonesia. Chulalongkorn University successfully hosted SCDS2018 from 15-16 August 2018. In 2019, Kyushu Institute of 
        Technology (KYUTECH), Iizuka, Japan, successfully hosted SCDS2019 from 28-29 August 2019. The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) 
        has successfully hosted virtually by IBDAAI (Institute for Big Data Analytics and Artificial Intelligence), UiTM, with the collaborations of the Faculty of Computer and 
        Mathematical Sciences, UiTM, Department of Statistics, Faculty of Science and Data Analytics, Institut Teknologi Sepuluh Nopember (ITS), Surabaya, Indonesia, and Research 
        Nexus, UiTM from 2-3 November 2021. 
    </p>

    <p style={{ textAlign:'justify'}}>The 7<sup>th</sup> International Conference on Soft Computing in Data Science 2023 (SCDS2023) will be hosted virtually by IBDAAI (Institute for Big Data 
        Analytics and Artificial Intelligence), UiTM, with the collaboration of Baoji University of Arts and Sciences, Shaanxi, China, from 24-25 January 2023. The conference's 
        theme is 'Science in Analytics: Harnessing Data and Simplifying Solutions'. SCDS2023 has invited renowned international and local keynote speakers who are academia or 
        practitioners to share their knowledge and experience in the application of soft computing in various disciplines. This conference aims to provide a platform for researchers 
        and practitioners to share their research work and create rigorous international research collaborations.SCDS2023 targets participants from universities, government agencies, 
        and industries to bridge the gap between academia and the industry. Research collaborations between academia and industry can advance useful analytics and computing 
        applications for providing real-time insights and solutions. 
    </p>
    </div>
    

    {/* <Row>
        <Col md='auto'>                                              
          <Image src={img1}/>   
        </Col>                     
    </Row>

    <br/>        

    <p style={{ textAlign:'justify'}}>
        The SCDS2015, SCDS2016, SCDS2017, SCDS2018 and SCDS2019 proceedings were published in the Communications in Computer and 
        Information Science series which is abstracted (indexed) by DBLP, EI, Scopus and were submitted for the inclusion in ISI 
        Proceedings. Authors of accepted papers will be invited to submit extended paper to: 
    </p>  

    <p>{'\u2022'} Applied Soft Computing, Elsevier.(Q1: Fast Track Submission) </p>
    <p>{'\u2022'} Journal of Information and Communication Technology (JICT) <br/> &nbsp; (uum.edu.my) (Q2) </p>
    <p>{'\u2022'} Pertanika Journal of Science and Technology (with additional publication charge of RM750) <br/> &nbsp; http://pertanika.upm.edu.my/JST.php (Q3) </p>

    <Container style={{justifyContent: 'center', margin: 'auto'}}>
        <Row style={{justifyContent: 'center', margin: 'auto'}}>      
            <Col>
                <img src={book1} alt="wrapkit" width= "180px" height="250px"/> 
            </Col>    
            <Col>
                <img src={book2} alt="wrapkit" width= "180px" height="250px"/> 
            </Col>     
            <Col>
                <img src={book4} alt="wrapkit" width= "180px" height="250px"/> 
            </Col>     
                    
        </Row>
    </Container>  */}

    <br/> 

    <h2>Keynote Speakers</h2> <br/> 

    <Container style={{ width: '100%' }}>
        <Row>
            <Col >
                <CardGroup>
                <Card >
                        <Card.Img width="100px" height="auto" src={speaker1} alt="YBhg Dato' Sri Dr Mohd Uzir Mahidin" />
                        <Card.Body>
                            <Card.Title tag="h5">YBhg Dato' Sri Dr Mohd Uzir Mahidin</Card.Title>    
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">Chief Statistician Malaysia</Card.Subtitle>
                            <Card.Text><u>Research Areas</u> <br/> Big Data Analytics, Economics</Card.Text>
                            <Card.Text><u>Speech Title</u> <br/>Managing Multiple Data Sources for Analytics in Assisting the Government’s Policy Formulation</Card.Text>
                            {/* <Button onClick={() => history.push('/scds2023/abstract-datosridruzirmahidin')}>Abstracts</Button> */}
                            <Link to={'/scds2023/abstract-datosridruzirmahidin'}>
                                <Button >Abstracts</Button>
                            </Link>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Img width="100px" height="auto" src={speaker2} alt="Prof Dr Eisuke Kita" />
                        <Card.Body>
                            <Card.Title tag="h5">Prof Dr Eisuke Kita</Card.Title>
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">Institute of Liberal Arts and Sciences, Nagoya University, Japan</Card.Subtitle>
                            <Card.Text><u>Speech Title</u> <br/>Application of Data Science in Agriculture</Card.Text>
                            {/* <Button onClick={() => history.push('/scds2023/abstract-profdreisukekita')}>Abstracts</Button> */}
                            <Link to={'/scds2023/abstract-profdreisukekita'}>
                                <Button >Abstracts</Button>
                            </Link>
                        </Card.Body>
                    </Card>
                    <Card >  
                        <Card.Img width="100px" height="auto" src={speaker3} alt="Prof Dr Agus Harjoko" />
                        <Card.Body>
                            <Card.Title tag="h5">Prof Dr Agus Harjoko</Card.Title>    
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">Department of Computer Science and Electronics (DCSE), Universitas Gadjah Mada</Card.Subtitle>
                            <Card.Text><u>Speech Title</u> <br/>Multimodal Analytics in Security Authentication</Card.Text>
                            {/* <Button onClick={() => history.push('/scds2023/abstract-profdragusharjoko')}>Abstracts</Button> */}
                            <Link to={'/scds2023/abstract-profdragusharjoko'}>
                                <Button >Abstracts</Button>
                            </Link>
                        </Card.Body>
                    </Card>
                    <Card >
                        <Card.Img width="100px" height="auto" src={speaker4} alt="Dr Mazlan Abbas" />
                        <Card.Body>
                            <Card.Title tag="h5">Dr Mazlan Abbas</Card.Title>    
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">CEO & Co-Founder of FAVORIOT</Card.Subtitle>
                            <Card.Text><u>Speech Title</u> <br/>IoT Analytics From Data to Decision Making - Trends & Challenges</Card.Text>
                            {/* <Button onClick={() => history.push('/scds2023/abstract-drmazlanabbas')}>Abstracts</Button> */}
                            <Link to={'/scds2023/abstract-drmazlanabbas'}>
                                <Button >Abstracts</Button>
                            </Link>
                        </Card.Body>
                    </Card>
                    <Card >
                        <Card.Img width="100px" height="auto" src={speaker5} alt="Associate Prof Dr Kun Zhan" />
                        <Card.Body>
                            <Card.Title tag="h5">Associate Prof Dr Kun Zhan</Card.Title>    
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">School of Information Science & Engineering, Lanzhou University </Card.Subtitle>
                            <Card.Text><u>Speech Title</u> <br/>Multiview Clustering Strategy for Multiple Features in Data Analytics</Card.Text>
                            {/* <Button onClick={() => history.push('/scds2023/abstract-assocprofdrkunzhan')}>Abstracts</Button> */}
                            <Link to={'/scds2023/abstract-assocprofdrkunzhan'}>
                                <Button >Abstracts</Button>
                            </Link>
                        </Card.Body>
                    </Card>
                                     
                </CardGroup>            
            </Col>        
        </Row>
    </Container>

    <Container >
        <Row >
            <Col>
                <CardGroup>
                    {/* <Card >
                        <Card.Img width="100px" height="auto" src={speaker1} alt="Card image cap" />
                        <Card.Body>
                            <Card.Title tag="h5">Dr Mazlan Abbas</Card.Title>
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">CEO & Co-Founder of FAVORIOT</Card.Subtitle>
                            <Card.Text><u>Research Areas</u> <br/>The future of IoT</Card.Text>
                        </Card.Body>
                    </Card> */}
                   
                    
                    {/* <Card >
                        <Card.Img width="100px" height="auto" src={speaker1} alt="Card image cap" />
                        <Card.Body>
                            <Card.Title tag="h5">Professor Dr. Guan-Hua, Huang</Card.Title>
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">Institute of Statistics, <br/> National Yang Ming Chiao Tung University, Taiwan.</Card.Subtitle>
                            <Card.Text><u>Research Areas</u> <br/> Aging, Nursing, Schizophrenia, Diabetes, Sensory Impairments (hearing, vision, olfaction), Data Science</Card.Text>
                            <Button onClick={() => history.push('/scds2021/abstract-professordrguanhuahuang')}>Abstracts</Button>
                        </Card.Body>
                    </Card> */}
                    {/* <Card >
                        <Card.Img width="100px" height="auto" src={speaker4} alt="Card image cap" />
                        <Card.Body>
                            <Card.Title tag="h5">Professor Dr.rer.pol. Heri Kuswanto</Card.Title>
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">Faculty of Science and Data Analytics, <br/> Institute Teknologi Sepuluh Nopember, Indonesia.</Card.Subtitle>
                            <Card.Text><u>Research Areas</u> <br/> Computational Statistics, Econometrics, Extreme Weather and Climate</Card.Text>
                            <Button onClick={() => history.push('/scds2021/abstract-professordrrerpolherikuswanto')}>Abstracts</Button>
                        </Card.Body>
                    </Card> */}
                </CardGroup>            
            </Col>        
        </Row>
        {/* <Row>
            <Col>
                <CardGroup>
                <Card >
                        <Card.Img width="100px" height="auto" src={speaker5} alt="Card image cap" />
                        <Card.Body>
                            <Card.Title tag="h5">Associate Professor Dr. Aiden Doherty</Card.Title>
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">Group Leader, <br/> Oxford Big Data Institute Oxford University, UK.</Card.Subtitle>
                            <Card.Text><u>Research Areas</u> <br/> Wearable Sensors, Machine Learning, Genomics</Card.Text>
                            <Button onClick={() => history.push('/scds2021/abstract-associateprofessordraidendoherty')}>Abstracts</Button>
                        </Card.Body>
                    </Card>
                    <Card >
                        <Card.Img width="100px" height="auto" src={speaker3} alt="Card image cap" />
                        <Card.Body>
                            <Card.Title tag="h5">Associate Professor Dr Simon Fong</Card.Title>
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">Information Science Department, <br/> University of Macau, China.</Card.Subtitle>
                            <Card.Text><u>Research Areas</u> <br/> E-Commerce, Data Mining, Business Intelligence, Intelligent Agent Technology, Electronic Governance</Card.Text>
                            <Button onClick={() => history.push('/scds2021/abstract-associateprofessordrsimonfong')}>Abstracts</Button>
                        </Card.Body>
                    </Card>
                    <Card >
                        <Card.Img width="100px" height="auto" src={speaker2} alt="Card image cap" />
                        <Card.Body>
                            <Card.Title tag="h5">Professor Dr. Richard C Millham</Card.Title>
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">Durban University of Technology Kwazulu Natal, South Africa.</Card.Subtitle>
                            <Card.Text><u>Research Areas</u> <br/> Cloud Computing, Big Data, Social Media, Security and Creative Computing</Card.Text>
                            <Button onClick={() => history.push('/scds2021/abstract-professorrichardmillham')}>Abstracts</Button>
                        </Card.Body>
                    </Card>
                    <Card >
                        <Card.Img width="100px" height="auto" src={speaker6} alt="Card image cap" />
                        <Card.Body>
                            <Card.Title tag="h5">Assistant Professor Dr. Ubydul Haque</Card.Title>
                            <Card.Subtitle tag="h6" className="mb-2 text-muted">University of North Texas Health Science Center.</Card.Subtitle>
                            <Card.Text><u>Research Areas</u> <br/> Spatial epidemiology, Statistical Modeling, Big Data Analytics</Card.Text>
                            <Button onClick={() => history.push('/scds2021/abstract-assistantprofessordrubydulhaque')}>Abstracts</Button>
                        </Card.Body>
                    </Card>
                </CardGroup>
            </Col>
        </Row> */}
    </Container>

    <br/>    
    <a href={poster} target="_blank">Poster SCDS 2023</a> 

    {/* <br/>  */}
    {/* <Container> 
        <Row className="justify-content-md-center">  
            <Col md="auto">
                <p>Download SCDS 2021 poster <a href={poster} target="_blank" rel="noreferrer">here</a> </p>                   
            </Col>
        </Row>
        <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={poster} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>  */}

    <br/>   
    {/* <NavbarBrand href="/"><img flex="1" alignSelf="stretch" src={sponsor} alt="wrapkit" height= "undefined," width= "undefined,"/></NavbarBrand>
    */}

    <Container>
         <Row>
            <Col>
                <img src={sponsor} height="100%" width="100%" alt=""/>
            </Col>
        </Row>                 
    </Container>           

                             
  </div>
)


